import { IonAlert, IonButton, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonRow, useIonToast } from "@ionic/react";
import { AxiosResponse } from "axios";
import { useState } from "react";
import { useHistory } from "react-router";
import { ApiChangeSoQuanTrang } from "../apiproviders/dataprovider";
import { createStore } from "../data/persistent/IonicStore";
import './UserProfile.css';
interface IUserInfo{
    username: string;
    hoten: string;
    ngaysinh: string;
    soquantrang: number;
    gioitinh: string;
    vongeo: number;
    sophong: string;
    [prop:string]: any;
}
interface IUseerInfoProp{
    item: IUserInfo
}
export const UserProfile: React.FC<IUseerInfoProp> = ({item})=>{
    const [soquantrang,setSoquantrang] = useState<number>(item.vongeo);
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [msgHeader, setMsgHeader] = useState<string>("Thông báo");
    const [presentToast, dismissToast] = useIonToast();
    const [hasUpdate, setHasUpdate] = useState<boolean>(false);
    const history = useHistory(); 
    const updSoquantrangHandle = async()=>{
        let dataRequest = {
            mathisinh: item.mathisinh,
            token: item.token,
            vongeo: soquantrang,
        };
        if(soquantrang <= 30 || soquantrang >=160){
            setIserror(true);
            setMsgHeader("Lỗi nhập liệu!");
            setMessage("Số đo vòng bụng không hợp lệ,Giá trị nhâp từ 30cm đến 160cm!");
            setHasUpdate(false);
            return ;
        }
        
        //console.log("cap nhat so quan trang");
        ApiChangeSoQuanTrang(dataRequest).then(async(res: AxiosResponse)=>{
            if([200,204].indexOf(res.status) !==-1){
                let lcStoreage = await createStore();
                let new_item = {...item, vongeo: soquantrang}; 
                await lcStoreage.set("login_info", JSON.stringify(new_item));
                presentToast("Cập nhật số đo vòng eo thành công", 3000);
                setIserror(true);
                setMsgHeader('Thông báo!');
                setHasUpdate(true);
                if(soquantrang <=50){
                    setMessage('Số đo vòng bụng quá nhỏ. Đây là số đo vòng quanh bụng. Nếu sai, hãy cập nhật lại chỉ số này');
                }else{
                    setMessage(`Cập nhật số đo vòng eo thành công ${new_item.vongeo} (cm)`);
                }
            }else{
                setIserror(true);
                setMsgHeader("Lỗi");
                setMessage("Lỗi cập nhật số đo vòng eo");
            }
        }).catch(error=>{
            console.log(error);
            setMsgHeader("Lỗi");
            setMessage("Lỗi cập nhật số đo vòng eo (lỗi mạng)");
            setIserror(true);
        })
    }
    return <>
    <IonContent>
        <IonGrid>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Mã số sinh viên</IonLabel></IonCol>
                <IonCol className="cell-class"><IonLabel>{item.mathisinh}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Họ tên</IonLabel></IonCol>
                <IonCol className="cell-class"><IonLabel>{item.hoten}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Ngày sinh </IonLabel></IonCol>
                <IonCol className="cell-class"><IonLabel>{item.ngaysinh}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Giới tính </IonLabel></IonCol>
                <IonCol className="cell-class"><IonLabel>{item.gioitinh}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Số phòng </IonLabel></IonCol>
                <IonCol className="cell-class"><IonLabel>{item.sophong}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
                <IonCol className="cell-class"><IonLabel>Sinh viên nhập vào <a href='/HD_DKQUANTRANG.html' target="_blank">chu vi lưng quần hiện đang sử dụng </a> của mình (cm) </IonLabel><br/><img className="huongdando" src="/assets/imgs/cachdo.png" alt="Cách đo vòng bụng dùng trang phục có sẵn"/></IonCol>
                <IonCol className="cell-class">
                    <IonItem>
                        <IonInput onIonChange={(e: CustomEvent)=>{
                            setSoquantrang(e.detail.value);
                        }} type={"number"} value ={soquantrang}
                        />
                    </IonItem>
                </IonCol>
            </IonRow>
        </IonGrid>
        <IonButton onClick={updSoquantrangHandle} expand="block">Cập nhật</IonButton>
        <IonAlert
            isOpen={iserror}
            onDidDismiss={async() => {
                setIserror(false);
                if(hasUpdate === true){
                    let lcStorage = await createStore();
                    await lcStorage.remove('login_info');
                    history.push('/login');
                }
            }}
            cssClass="my-custom-class"
            header={msgHeader}
            message={message}
            buttons={["ĐÓNG"]}
        />
    </IonContent>
    </>
    
}